import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectMill } from "../actions/millActions";

import { withRouter } from "react-router-dom";

import { ReactComponent as SearchIcon } from "../icons/search.svg";

import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ListItem from "@material-ui/core/ListItem";
import Popper from "@material-ui/core/Popper";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  tooltip: {
    backgroundColor: "white",
    color: "#00568E",
    fontSize: "9pt",
    border: "1px solid #00568E",
  },
  inputBase: {
    color: "inherit",
    "& .MuiInputBase-input": {
      padding: 0,
      transition: theme.transitions.create("width"),
      height: "28px",
      width: "0px",
      borderRadius: "4px",
      backgroundColor: "rgba(255, 255, 255, 0.15)",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.25)",
      },
    },
  },
  popper: {
    zIndex: "1304 !important",
  },
});

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      value: "",
    };
  }

  toggle = () => {
    this.setState({
      open: !this.state.open,
      value: "",
    });
  };

  render() {
    return this.props.mills ? (
      <div
        style={{
          margin: "0 10px",
          display: "flex",
        }}
      >
        <Tooltip
          title="Suche"
          classes={{
            tooltip: this.props.classes.tooltip,
          }}
        >
          <SearchIcon
            onClick={(e) => {
              this.toggle();
            }}
            style={{ cursor: "pointer" }}
            className="search-button"
          />
        </Tooltip>
        <Autocomplete
          open={this.state.open}
          // openOnFocus
          onClose={(event, reason) => {
            if (reason === "blur" || reason === "escape") {
              this.toggle();
            }
          }}
          PopperComponent={Popper}
          classes={{ popper: this.props.classes.popper }}
          freeSolo
          inputValue={this.state.value}
          options={this.state.value.length > 0 ? this.props.mills.features : []}
          filterOptions={(options) => {
            var results = options.filter((opt) =>
              new RegExp(this.state.value, "i").test(opt.properties.Name)
            );
            if (results.length === 0 && this.state.value.length > 0) {
              return [
                {
                  properties: { Name: "keine Übereinstimmung" },
                },
              ];
            } else {
              return results;
            }
          }}
          getOptionLabel={(option) =>
            option.properties.Name ? option.properties.Name : ""
          }
          groupBy={(option) => {
            return option.properties.Gemeinde;
          }}
          renderOption={(props, option) => {
            return (
              <ListItem
                {...props}
                disableGutters
                onClick={() => {
                  if (props.properties.Name === "keine Übereinstimmung") {
                    this.setState({ value: "" });
                  } else {
                    this.props.selectMill(props.properties, "map");
                    this.props.history.push(
                      `/muehlenkataster/${props.properties.Gemeinde.toLowerCase()}/${
                        props.properties.Objektnr.split("_")[1]
                      }`
                    );
                  }
                }}
              >
                {props.properties.Name}
              </ListItem>
            );
          }}
          style={{ margin: "auto" }}
          renderInput={(params) => {
            return (
              <InputBase
                classes={{ root: this.props.classes.inputBase }}
                id="sucheingabe"
                placeholder="Mühle suchen"
                // autoFocus
                inputRef={params.InputProps.ref}
                inputProps={{
                  ...params.inputProps,
                  style: this.state.open
                    ? {
                        padding: "0 35px 0 10px",
                        marginLeft: "5px",
                        width: "220px",
                      }
                    : {},
                  value: this.state.value,
                  onChange: (e) => {
                    this.setState({ value: e.target.value });
                  },
                }}
              />
            );
          }}
        />
      </div>
    ) : null;
  }
}

Search.propTypes = {
  mills: PropTypes.object.isRequired,
  selectMill: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  mills: state.mill.mills,
});

export default connect(mapStateToProps, {
  selectMill,
})(withStyles(styles, { withTheme: true })(withRouter(Search)));
